import * as React from 'react';
import type { SVGProps } from 'react';

const IconFacebook = (props: SVGProps<SVGSVGElement>) => (
  <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8 13" {...props}>
    <path
      d="M5.487 3.042c-.122 0-.27.057-.444.17-.174.113-.261.283-.261.51v.68h2.064v2.717H4.782v5.487H2.064V7.119H0V4.4h2.064V3.042c0-.348.079-.688.235-1.019.157-.33.38-.622.667-.875A3.54 3.54 0 0 1 3.972.534 3.281 3.281 0 0 1 5.226.299h2.3v2.743H5.486Z"
      fill="currentColor"
    />
  </svg>
);
export default IconFacebook;
